import { AxiosResponse } from 'axios';
import instanceApiClient from '@/services/InstanceApiClient';
import { Instance } from '@/models/models';

const instanceMemoryCache = new Map<string, Instance>();

export default class InstanceService {
  public async getInstance(): Promise<Instance> {
    const slug = this.getInstanceSlugFromUrl();

    const cachedInstance = instanceMemoryCache.get(slug);
    if (cachedInstance) return cachedInstance;

    return this.fetchInstance(slug);
  }

  private async fetchInstance(slug: string): Promise<Instance> {
    const response: AxiosResponse<Instance> = await instanceApiClient.get(`instance/data/${slug}`);
    const instance = response.data;

    if (!instance || !instance.slug || !instance.token) {
      throw new Error('Instance not found');
    }

    instanceMemoryCache.set(slug, instance);
    return instance;
  }

  private getInstanceSlugFromUrl(): string {
    const slug = window.location.pathname.split('/')[1];
    if (!slug) throw new Error('Instance slug not found');
    return slug;
  }
}
